// extracted by mini-css-extract-plugin
export default {"boxArea":"PaymentLanding_boxArea__13vvk"};